export default __webpack_public_path__ + "static/media/call.2e29b0f5.mp3";